import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  TextField,
  Button,
  DialogActions,
  DialogContentText,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";

const API_URI = process.env.REACT_APP_BACKEND_URL;

function headers(token = null) {
  return {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("access"),
    },
  };
}

export const RequestSourceModal = ({ show, onHide }) => {
  const [input, setInput] = useState("");

  function tempAlert(msg, duration) {
    var el = document.createElement("div");
    el.setAttribute(
      "style",
      "position:absolute;" +
        "top: 7rem;" +
        "left:25%;" +
        "right: calc(25% - 65px); ;" +
        "text-align: center;" +
        "background-color: #95a0e3;" +
        "margin:1rem auto;" +
        "padding: 1% 0.5% 1% 0.5%;" +
        "border: 2px solid #c2c2c2;" +
        "border-radius: 15px;" +
        "margin-top: 5%;"
    );
    el.innerHTML = msg;
    setTimeout(function () {
      el.parentNode.removeChild(el);
    }, duration);
    document.body.appendChild(el);
  }

  function submitForm(e, input) {
    e.preventDefault();
    onHide();
    var bodyFormData = new FormData();
    bodyFormData.append("url", input);
    axios
      .post(`${API_URI}/sources/add/`, bodyFormData, headers())
      .then((res) => {
        console.log(res);
        console.log(res.data);
      });
    tempAlert(
      "Dank für die Anfrage. Wir kümmern uns darum, dass Ihnen die Quelle schon" +
        "bald zur Verfügung steht. <br> Ihr Team Faktual",
      5000
    );
  }
  return (
    <Dialog open={show} onClose={onHide} aria-labelledby="form-dialog-title">
      <form onSubmit={(e) => submitForm(e, input)}>
        <DialogTitle id="form-dialog-title">Add Source</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bitte geben Sie die URL der Quelle ein, die Sie
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="url"
            label="http://www.example.com"
            type="input"
            fullWidth
            onChange={(e) => setInput(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={onHide}>
            Abbruch
          </Button>
          <Button color="primary" type="submit">
            Adden
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
